<div class="eiq-select__container" [class.eiq-select__container--sm]="size() === 'sm'" [class.eiq-select__container--has-label]="label()">
  @if (label()) {
    <span class="fs__sm fw__500 label">
      {{ label() }} <span class="fs__xs caption">{{ hint() }}</span>
    </span>
  }

  <span class="eiq-select__container-form">
    <mat-form-field
      appearance="outline"
      class="eiq-select__field"
      [class.eiq-select__field--invalid]="isInvalid()"
      [class.mat-form-field-invalid]="isInvalid()"
      [subscriptSizing]="'dynamic'"
    >
      @if (icon()) {
        <fa-icon matIconPrefix [icon]="icon()" class="eiq-select__prefix-icon"></fa-icon>
      }
      <mat-select
        [attr.data-testid]="testId() ? testId() + '-select' : null"
        [value]="currentValue"
        [multiple]="multiple()"
        [disabled]="control.disabled || loading()"
        [placeholder]="placeholder()"
        [class.mat-mdc-select-invalid]="isInvalid()"
        (selectionChange)="setValue($event)"
        (openedChange)="!$event && searchInput.set('')"
      >
        @if (enableFilter()) {
          <div class="eiq-select__container__input">
            <eiq-input placeholder="Search..." [(ngModel)]="searchInput" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
          </div>
        }

        @if (showDefaultOption()) {
          <mat-option [value]="defaultOptionValue">{{ defaultOption() }}</mat-option>
        }

        @for (option of options(); track option.value) {
          <mat-option [disabled]="option.disabled === true" [value]="option.value" [class.hidden-mat-option]="hiddenValues$().has(option.value)">
            {{ option.text }}
          </mat-option>
        }

        @if (hiddenValues$().size === options()?.length) {
          <p disabled class="eiq-select__container__no-results text__sm">No results found</p>
        }
      </mat-select>
    </mat-form-field>
    @if (loading()) {
      <mat-spinner diameter="20" color="light"></mat-spinner>
    }
  </span>

  @if (isInvalid()) {
    <div class="eiq-select__error mat-mdc-form-field-error">
      <eiq-validation-text [formCtrl]="control"></eiq-validation-text>
    </div>
  }
</div>
